/**
 * Password policy mirrored from `backend.security.password_policy_errors`.
 * Keep this in sync with the backend rules so we never let a client-side
 * "valid" password fail server-side validation.
 */

export interface PasswordRule {
  id: string;
  label: string;
  test: (v: string) => boolean;
}

export const PASSWORD_RULES: PasswordRule[] = [
  { id: 'length', label: 'At least 12 characters', test: (v) => v.length >= 12 },
  { id: 'lower', label: 'A lowercase letter', test: (v) => /[a-z]/.test(v) },
  { id: 'upper', label: 'An uppercase letter', test: (v) => /[A-Z]/.test(v) },
  { id: 'digit', label: 'A number', test: (v) => /[0-9]/.test(v) },
  { id: 'special', label: 'A special character', test: (v) => /[^A-Za-z0-9]/.test(v) },
];

export function passwordIsStrong(v: string): boolean {
  return PASSWORD_RULES.every((rule) => rule.test(v));
}

/** Returns the ids of rules the password currently FAILS. */
export function failingPasswordRules(v: string): string[] {
  return PASSWORD_RULES.filter((rule) => !rule.test(v)).map((r) => r.id);
}
